import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';

import { SimpleCard } from '../common';
import { BulkMessageScheduleTable } from './BulkMessageScheduleTable';
import { ScheduledMessage } from './types';

interface BulkMessageSectionProps {
  scheduledMessages: ScheduledMessage[];
}

export const BulkMessageSection: React.FC<BulkMessageSectionProps> = ({ scheduledMessages }) => {
  const { t } = useTranslation();

  return (
    <Grid style={{ paddingBottom: '65px' }} container direction="row" justify="space-around">
      <Grid container direction="column" item sm={12}>
        <SimpleCard title={t('sections.bulkMessageSchedules')} maxWidth="100%">
          <BulkMessageScheduleTable scheduledMessages={scheduledMessages} />
        </SimpleCard>
      </Grid>
    </Grid>
  );
};
